<template>
  <div>
    <div id="map" style="height: 650px"></div>
    <!-- Modal for city description -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import apiClient from "@/plugins/apiService";

export default {
  props: ["selectedLab"],
  data() {
    return {
      map: null,
      selectedCity: { name: "", description: "" },
      dialog: false,
      cityData: null,
    };
  },
  mounted() {
    this.initMap();
    this.fetchLocationData(this.selectedLab);
  },
  watch: {
    selectedLab(newVal) {
      this.fetchLocationData(newVal);
    },
  },
  methods: {
    initMap() {
      // Center map on Europe (approximate coordinates for Europe view)
      this.map = L.map("map").setView([54.526, 15.2551], 4);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);
    },
    fetchLocationData(locationId) {
      apiClient
        .get(`/map/${locationId}`)
        .then((response) => {
          if (response.data.length > 0) {
            const location = response.data[0];
            this.cityData = {
              lat: location.latitude,
              lng: location.longitude,
            };
            this.addCircleMarker(this.cityData);
          } else {
            console.error("Location not found");
            // If location is not found, center the map on Europe
            this.map.setView([54.526, 15.2551], 4);
          }
        })
        .catch((error) => {
          console.error("Error fetching location data:", error);
          // If there is an error getting the data, center the map on Europe
          this.map.setView([54.526, 15.2551], 4);
        });
    },
    addCircleMarker(location) {
      // Clear existing layers
      this.map.eachLayer((layer) => {
        if (layer instanceof L.Circle) {
          this.map.removeLayer(layer);
        }
      });

      L.circle([location.lat, location.lng], {
        color: "red",
        fillColor: "red",
        fillOpacity: 0.5,
        radius: 5000, // Circle radius in meters
      }).addTo(this.map);

      // Center the map on the location
      this.map.setView([location.lat, location.lng], 10);
    },
  },
};
</script>

<style scoped>
#map {
  width: 500px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
</style>
